import React, { FC } from 'react'

//* utils
import { MediaTextMaskNone } from '../../../../constants/svg'
import ImgUtil from '../../../../utils/img.utils'

//* components
import VideoPlayer from '../../videoPlayer'
import WrapperImage from '../../wrapperImage'

type Props = {
  mediaTextData: any
  video: any
  handleOpen: () => void
  enlargable: boolean
}

export const ImageContainer: FC<Props> = ({ mediaTextData, video, handleOpen, enlargable }) => {
  const type = (mediaStyle: string) => {
    switch (mediaStyle) {
      case 'Video':
        return 'VIDEO'
      case 'Photo':
        return '16X9'
      default:
        return 'NONE'
    }
  }

  const mask = type(mediaTextData.mediaStyle)

  return (
    <div className="MediaText__Image-Container" onClick={handleOpen}>
      <div className="MediaText__Mask-Wrapper">
        {mask === 'NONE' && (
          <div className="MediaText__Mask--None">
            {enlargable && <MediaTextMaskNone />}

            {video.animation && video.animationMP4 ? (
              <video src={mediaTextData.asset.url} playsInline autoPlay muted loop />
            ) : (
              <WrapperImage
                alt={mediaTextData.asset.altText}
                src={ImgUtil.getResizedImageUrl(mediaTextData.asset.url, '')}
                loading="lazy"
                width={690}
                height={690}
                threshold={650}
              />
            )}
          </div>
        )}

        {mask === 'VIDEO' && (
          <div className="MediaText__Mask--Video">
            <VideoPlayer
              width={'100%'}
              height="429"
              videoId={video.id}
              videoUrl={video.url}
              img={mediaTextData.asset.url}
              type={video.type}
              backgroundAltText={mediaTextData.asset.altText}
              backgroundImgParams={'width=690'}
              start={mediaTextData.asset.start}
              playInPlace={mediaTextData.playInPlace}
            />
          </div>
        )}

        {mask === '16X9' && (
          <div className="MediaText__Mask--Image">
            <WrapperImage
              src={ImgUtil.getResizedImageUrl(mediaTextData.asset.url, '')}
              loading="lazy"
              alt={mediaTextData.asset.altText}
              width={690}
              height={690}
              threshold={650}
            />
          </div>
        )}
      </div>
    </div>
  )
}
